module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"download":"ダウンロード"},"en":{"download":"Download"}}')
  delete Component.options._Ctor
}
